import React from 'react';
import Hero from '../components/Hero';
import Counters from '../components/Counters';
import Slider from '../components/Slider';
import Services from '../components/Services';
import DiscussProject from '../components/DiscussProject';
import BrandMakers from '../components/BrandMakers';
import ExperiencedProfessionals from '../components/ExperiencedProfessionals';
import HowItWorks from '../components/HowItWorks';
import StatsGrid from '../components/StatsGrid';
import PartnerLogos from '../components/PartnerLogos';
import ScratchToImplementation from '../components/ScratchToImplementation';
import UpgradeExperience from '../components/UpgradeExperience';
import ContactUs from '../components/ContactUs';
import CreateBrands from '../components/CreateBrands';

function Home({ setView }) {
  return (
    <>
      <Hero setView={setView} />
      <Counters />
      <Slider setView={setView} />
      <Services setView={setView} />
      <DiscussProject setView={setView} />
      <BrandMakers />
      <ExperiencedProfessionals setView={setView} />
      <HowItWorks setView={setView} />
      <StatsGrid />
      <PartnerLogos />
      <ScratchToImplementation setView={setView} />
      <UpgradeExperience setView={setView} />
      <ContactUs />
      <CreateBrands setView={setView} />
    </>
  );
}

export default Home;
